import { Pipe, PipeTransform } from '@angular/core';

import { Section } from 'app/providers/storage-api/analysis.service';
@Pipe({
  name: 'collectionSectionSeparator',
  standalone: false,
})
export class CollectionSectionSeparatorPipe implements PipeTransform {
  transform(item: Section, collectionSectionSeparator: string): string {
    if (!item?.metadata) {
      return null;
    }

    for (const [key, value] of Object.entries(item.metadata)) {
      if (key === collectionSectionSeparator) {
        return value;
      }
    }
  }
}
